import { useState } from "react";
import { Menu, X } from "lucide-react";
import { useLang } from "@/i18n";

const linkDefs = [
  { href: "#applicazioni", key: "applicazioni" },
  { href: "#tecnologia", key: "tecnologia" },
  { href: "#finanza", key: "finanza" },
  { href: "#startup", key: "startup" },
  { href: "#news", key: "news" },
  { href: "#faq", key: "faq" },
];

export const scrollTo = (href) => {
  if (window.__lenis) window.__lenis.scrollTo(href, { offset: -70 });
  else document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
};

function LangToggle() {
  const { lang, setLang } = useLang();
  return (
    <div className="flex items-center rounded-full border border-white/15 overflow-hidden" data-testid="lang-toggle">
      {["it", "en"].map((l) => (
        <button key={l} onClick={() => setLang(l)} data-testid={`lang-${l}-button`}
          className={`px-3 py-1.5 text-xs font-semibold uppercase transition-colors duration-200 ${lang === l ? "bg-volt text-anthracite" : "text-steel hover:text-white"}`}>
          {l}
        </button>
      ))}
    </div>
  );
}

export default function Header() {
  const [open, setOpen] = useState(false);
  const { t } = useLang();
  const links = linkDefs.map((l) => ({ href: l.href, label: t.nav[l.key] }));

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-md bg-anthracite/80 border-b border-white/10" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-6 h-[70px] flex items-center justify-between">
        <button onClick={() => scrollTo("#top")} className="flex items-center gap-2.5" data-testid="logo-button">
          <img src="/assets/logo.png" alt="VPS Group" className="h-8 w-auto" />
          <span className="font-display font-bold text-lg tracking-tight">VPS<span className="text-steel font-medium"> GROUP</span></span>
        </button>
        <nav className="hidden xl:flex items-center gap-7" data-testid="main-nav">
          {links.map((l) => (
            <button key={l.href} onClick={() => scrollTo(l.href)} data-testid={`nav-${l.key === undefined ? l.label : l.href.slice(1)}`}
              className="text-sm text-steel hover:text-white transition-colors duration-200">
              {l.label}
            </button>
          ))}
          <LangToggle />
          <button onClick={() => scrollTo("#contatti")} className="btn-primary !py-2.5 !px-5" data-testid="nav-cta-button">
            {t.nav.cta}
          </button>
        </nav>
        <div className="xl:hidden flex items-center gap-3">
          <LangToggle />
          <button className="text-white" onClick={() => setOpen(!open)} data-testid="mobile-menu-button" aria-label="Menu">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="xl:hidden border-t border-white/10 bg-anthracite/95 backdrop-blur-md px-6 py-4 flex flex-col gap-4" data-testid="mobile-menu">
          {links.map((l) => (
            <button key={l.href} onClick={() => { setOpen(false); scrollTo(l.href); }} data-testid={`mobile-nav-${l.href.slice(1)}`}
              className="text-left text-sm text-steel hover:text-white">
              {l.label}
            </button>
          ))}
          <button onClick={() => { setOpen(false); scrollTo("#contatti"); }} className="btn-primary w-fit !py-2.5 !px-5" data-testid="mobile-cta-button">
            {t.nav.cta}
          </button>
        </div>
      )}
    </header>
  );
}
